import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { appLinkConstants } from '@tran-monorepo/frontend/constants';
import { SiTooltipDirective } from '@siemens/element-ng/tooltip';

@Component({
    selector: 'tran-chatbot-bubble',
    imports: [TranslateModule, SiTooltipDirective],
    templateUrl: './chatbot-bubble.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatbotBubbleComponent {
    protected readonly chatbotUrl = appLinkConstants.chatbotLink;
}
